import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['storePaymentMethod', 'amount', 'currency']

  toggleFields() {
    this.currencyTarget.disabled = this.storePaymentMethodTarget.checked
    this.amountTarget.disabled = this.storePaymentMethodTarget.checked
  }
}
